import axios from "axios"
import { del, get, post, put } from "./api_helper"
import { getAccessToken } from "./jwt-token-access/accessToken"

const API_BASE_URL = `${process.env.REACT_APP_API_INT_LEADS}/api`

const authHeader = () => ({
  headers: { "x-access-token": getAccessToken() },
})

export const getParceiros = (tipo) => {
  const url = tipo
    ? `${API_BASE_URL}/parceiros?tipo=${tipo}`
    : `${API_BASE_URL}/parceiros`
  return get(url, authHeader())
}

export const getParceiroById = (id) =>
  get(`${API_BASE_URL}/parceiros/${id}`, authHeader())

export const createParceiro = ({ Nome, Tipo, Cnpj, CodigoSusep }) =>
  post(`${API_BASE_URL}/parceiros`, { Nome, Tipo, Cnpj, CodigoSusep }, authHeader())

export const updateParceiro = (id, { Nome, Tipo, Cnpj, CodigoSusep }) =>
  put(`${API_BASE_URL}/parceiros/${id}`, { Nome, Tipo, Cnpj, CodigoSusep }, authHeader())

export const deleteParceiro = (id) =>
  del(`${API_BASE_URL}/parceiros/${id}`, authHeader())

export const getTemplatesByParceiro = (parceiroId) =>
  get(`${API_BASE_URL}/parceiros/${parceiroId}/templates`, authHeader())

export const createParceiroTemplate = (parceiroId, formData) =>
  axios.post(`${API_BASE_URL}/parceiros/${parceiroId}/templates`, formData, {
    headers: { "x-access-token": getAccessToken() },
  }).then(r => r.data)

export const updateParceiroTemplate = (parceiroId, templateId, formData) =>
  axios.put(`${API_BASE_URL}/parceiros/${parceiroId}/templates/${templateId}`, formData, {
    headers: { "x-access-token": getAccessToken() },
  }).then(r => r.data)

export const deleteParceiroTemplate = (parceiroId, templateId) =>
  del(`${API_BASE_URL}/parceiros/${parceiroId}/templates/${templateId}`, authHeader())

export const setParceiroTemplateAtivo = (parceiroId, templateId) =>
  put(
    `${API_BASE_URL}/parceiros/${parceiroId}/templates/${templateId}/ativo`,
    {},
    authHeader()
  )
